export type SalesOrdersTableColumnKey =
  | 'number'
  | 'description'
  | 'client'
  | 'type'
  | 'status'
  | 'total'
  | 'source'
  | 'responsible'
  | 'date';

export interface SalesOrdersTableColumnDescriptor {
  key: SalesOrdersTableColumnKey;
  labelKey: string;
  locked: boolean;
}

export type SalesOrdersTableColumnVisibility = Record<
  SalesOrdersTableColumnKey,
  boolean
>;

export const SALES_ORDERS_TABLE_COLUMNS: readonly SalesOrdersTableColumnDescriptor[] = [
  { key: 'number', labelKey: 'COMPONENTS.SALES_ORDERS.TABLE.NUMBER', locked: true },
  { key: 'description', labelKey: 'COMPONENTS.SALES_ORDERS.TABLE.DESCRIPTION', locked: true },
  { key: 'client', labelKey: 'COMPONENTS.SALES_ORDERS.TABLE.CLIENT', locked: false },
  { key: 'type', labelKey: 'COMPONENTS.SALES_ORDERS.TABLE.TYPE', locked: false },
  { key: 'status', labelKey: 'COMPONENTS.SALES_ORDERS.TABLE.STATUS', locked: false },
  { key: 'total', labelKey: 'COMPONENTS.SALES_ORDERS.TABLE.TOTAL', locked: false },
  { key: 'source', labelKey: 'COMPONENTS.SALES_ORDERS.TABLE.SOURCE', locked: false },
  { key: 'responsible', labelKey: 'COMPONENTS.SALES_ORDERS.TABLE.RESPONSIBLE', locked: false },
  { key: 'date', labelKey: 'COMPONENTS.SALES_ORDERS.TABLE.DATE', locked: false },
];

export function buildDefaultSalesOrdersColumnVisibility(): SalesOrdersTableColumnVisibility {
  const result = {} as SalesOrdersTableColumnVisibility;
  for (const column of SALES_ORDERS_TABLE_COLUMNS) {
    result[column.key] = true;
  }
  return result;
}

export function mergeSalesOrdersColumnVisibility(
  stored: Record<string, boolean>,
): SalesOrdersTableColumnVisibility {
  const result = buildDefaultSalesOrdersColumnVisibility();
  for (const column of SALES_ORDERS_TABLE_COLUMNS) {
    if (column.locked) {
      continue;
    }
    const storedValue = stored[column.key];
    if (typeof storedValue === 'boolean') {
      result[column.key] = storedValue;
    }
  }
  return result;
}

export function extractPersistableSalesOrdersVisibility(
  visibility: SalesOrdersTableColumnVisibility,
): Record<string, boolean> {
  const result: Record<string, boolean> = {};
  for (const column of SALES_ORDERS_TABLE_COLUMNS) {
    if (!column.locked) {
      result[column.key] = visibility[column.key];
    }
  }
  return result;
}
